import { Map, List } from 'immutable';

export function request(state, { id }) {
    let items = state.get('items').deleteIn([ id, 'single' ]);

    if ( items.get(id, Map()).size === 0 ) {
        items = items.delete(id);
    }

    return state.set('items', items);
}
